module.exports = __webpack_public_path__ + "img/coop_san_pedro.f4c00813.png";